import { useState } from 'react'
import { useAppState } from './Context'
import { IconMapPin } from '@react/common/icons'

function LocationFilters({ location }) {
  const { selectedFilters, filters } = useAppState()

  let targetFilters = Object.keys(filters)

  if (selectedFilters.length) {
    targetFilters = selectedFilters
  }

  return (
    <div className="flex flex-wrap gap-y-2 gap-x-3 mt-4">
      {targetFilters
        .filter((x) => location.thingsToDoIds.includes(parseInt(x)))
        .map((filterId) => {
          const filter = filters[parseInt(filterId)]

          if (filter.website) {
            return (
              <a
                href={filter.website}
                target="_blank"
                rel="noopener noreferrer"
                key={`location-${location.id}-${filterId}-has`}
                className="flex gap-1 items-baseline text-sm font-semibold underline hover:text-blue"
              >
                <span className="w-3">
                  <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m1 4.783 3.217 3.565L11 1"
                      stroke="#00853C"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>

                {filter.title}
              </a>
            )
          }

          return (
            <span
              key={`location-${location.id}-${filterId}-has`}
              className="flex gap-1 items-baseline text-sm font-semibold"
            >
              <span className="w-3">
                <svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m1 4.783 3.217 3.565L11 1"
                    stroke="#00853C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>

              {filter.title}
            </span>
          )
        })}

      {targetFilters
        .filter((x) => location.thingsToDoComingSoonIds.includes(parseInt(x)))
        .map((filterId) => {
          const filter = filters[parseInt(filterId)]

          if (filter.website) {
            return (
              <a
                href={filter.website}
                target="_blank"
                rel="noopener noreferrer"
                key={`location-${location.id}-${filterId}-soon`}
                className="flex gap-1 items-baseline text-sm font-semibold underline hover:text-blue"
              >
                <span className="relative top-0.5 w-3">
                  <svg viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.4 28.182c-6.958.009-12.605-5.662-12.614-12.666C2.778 8.51 8.412 2.826 15.371 2.817a12.548 12.548 0 0 1 7.934 2.819H21c-.773 0-1.4.63-1.4 1.409 0 .778.627 1.409 1.4 1.409h5.6c.772 0 1.4-.631 1.4-1.41V1.41C28 .63 27.372 0 26.6 0c-.774 0-1.4.63-1.4 1.409v2.157C18.648-1.886 8.946-.96 3.53 5.636c-5.417 6.594-4.497 16.36 2.055 21.812A15.33 15.33 0 0 0 15.401 31c.773 0 1.4-.63 1.4-1.409 0-.778-.627-1.409-1.4-1.409Z"
                      fill="#E69A09"
                    />
                    <path
                      d="M20.59 20.724a1.416 1.416 0 0 0 0-1.993l-3.79-3.815v-7.87c0-.779-.626-1.41-1.4-1.41-.772 0-1.399.631-1.399 1.41V15.5c0 .374.148.732.41.996l4.2 4.227c.546.55 1.432.55 1.98 0h-.001Z"
                      fill="#E69A09"
                    />
                  </svg>
                </span>

                <span>{filter.title} (Coming Soon)</span>
              </a>
            )
          }

          return (
            <span
              key={`location-${location.id}-${filterId}-soon`}
              className="flex gap-1 items-baseline text-sm font-semibold"
            >
              <span className="relative top-0.5 w-3">
                <svg viewBox="0 0 28 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.4 28.182c-6.958.009-12.605-5.662-12.614-12.666C2.778 8.51 8.412 2.826 15.371 2.817a12.548 12.548 0 0 1 7.934 2.819H21c-.773 0-1.4.63-1.4 1.409 0 .778.627 1.409 1.4 1.409h5.6c.772 0 1.4-.631 1.4-1.41V1.41C28 .63 27.372 0 26.6 0c-.774 0-1.4.63-1.4 1.409v2.157C18.648-1.886 8.946-.96 3.53 5.636c-5.417 6.594-4.497 16.36 2.055 21.812A15.33 15.33 0 0 0 15.401 31c.773 0 1.4-.63 1.4-1.409 0-.778-.627-1.409-1.4-1.409Z"
                    fill="#E69A09"
                  />
                  <path
                    d="M20.59 20.724a1.416 1.416 0 0 0 0-1.993l-3.79-3.815v-7.87c0-.779-.626-1.41-1.4-1.41-.772 0-1.399.631-1.399 1.41V15.5c0 .374.148.732.41.996l4.2 4.227c.546.55 1.432.55 1.98 0h-.001Z"
                    fill="#E69A09"
                  />
                </svg>
              </span>

              <span>{filter.title} (Coming Soon)</span>
            </span>
          )
        })}
    </div>
  )
}

function LocationCard({ location, hideByDefault, onClick }) {
  const [thingsToDoVisible, setThingsToDoVisible] = useState(false)

  return (
    <div data-id={location.id} className={`relative flex p-6 lg:px-8`}>
      <div className="flex-shrink-0 w-1/4 max-w-[160px]">
        {location.thingsToDoImage && (
          <img
            src={location.thingsToDoImage}
            loading="lazy"
            alt={location.title}
            className="rounded-xl cursor-pointer 2xl:rounded-3xl"
            onClick={onClick}
          />
        )}
      </div>

      <div className="flex-1 px-5 2xl:py-3">
        <h2
          className="font-semibold transition-colors cursor-pointer lg:text-xl lg:leading-snug 2xl:text-2xl text-green hover:text-blue"
          onClick={onClick}
        >
          {location.title}
        </h2>

        <div className="flex gap-2 items-start mt-2 text-sm cursor-pointer lg:text-base 2xl:text-lg" onClick={onClick}>
          <IconMapPin className="flex-shrink-0 w-4" />

          <address>
            {location.address} {location.city}, {location.state} {location.zip}
          </address>
        </div>

        {hideByDefault ? (
          <>
            <button
              type="button"
              className="mt-1 text-sm font-semibold underline 2xl:mt-2 2xl:text-base text-primary-hover"
              onClick={() => setThingsToDoVisible(!thingsToDoVisible)}
              aria-controls={`location-things-${location.id}`}
              aria-expanded={`${thingsToDoVisible ? 'true' : 'false'}`}
            >
              {thingsToDoVisible ? 'Hide' : 'Show'} Things To Do
            </button>

            <div
              id={`location-things-${location.id}`}
              className={`location-things-group ${thingsToDoVisible ? 'is-open' : ''}`}
            >
              <LocationFilters location={location} />
            </div>
          </>
        ) : (
          <LocationFilters location={location} />
        )}
      </div>
    </div>
  )
}

export default LocationCard
